<template>
  <section class="list-module module">
    <div class="bg-shape"></div>
    <div class="container">
      <div class="list-module-content">
        <div class="copy">
          <div
            class="eyebrow"
            v-html="data.list_module_tagline"></div>
          <div
            class="headline h3 font-med"
            v-html="data.list_module_headline"></div>
          <div
            class="text editor-formatting"
            v-html="data.list_module_text"></div>
        </div>
        <div class="list-actual">
          <div
            v-for="(item, index) in data.list_module_list"
            :key="index"
            class="lm-list-item font-large font-med"
            v-html="item.list_module_list_item"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "ListComponent",
    "CLASSNAME": "list-module",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */
defineProps(['data'])
</script>

<style lang="scss">
.list-module {
  .bg-shape {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 937px;
    background-image: url('@/assets/img/list-lines.svg');
    background-repeat: no-repeat;
    background-position: 90% top;
    transform-origin: top;

    @include mobile {
      display: none;
    }
  }

  .list-module-content {
    display: flex;
    align-items: flex-end;

    @include tablet-landscape(1) {
      flex-direction: column;
    }

    .copy {
      max-width: 422px;
      margin-right: 150px;

      @include tablet-landscape(1) {
        width: 100%;
        max-width: 100%;
        margin: 0 0 40px;
      }

      .eyebrow {
        margin: 0 0 40px;
      }

      .headline {
        margin: 0 0 24px;
      }
    }

    .list-actual {
      @include tablet-landscape(1) {
        width: 90%;
        margin: auto;
      }

      .lm-list-item {
        position: relative;
        margin: 0 0 10px;

        &:before {
          content: '';
          position: absolute;
          top: 18px;
          left: -28px;
          display: block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: $blue;
          box-shadow:
            0px 0px 12px $blue,
            0px 0px 28px $blue;
          transform: matrix(1, 0, 0, -1, 0, 0);
        }

        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
</style>
